import script from "./AppInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppInfo.vue?vue&type=script&setup=true&lang=ts"

import "./AppInfo.vue?vue&type=style&index=0&id=1414331e&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1414331e"]])

export default __exports__